<template>
  <div>
    <h3 :class="titleClass">
      Laskutuksen yhteenveto
    </h3>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th></th>
            <th>Summa</th>
            <th>Kpl</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Avoinna</td>
            <td>{{ asiakas.avoinna_summa | formatSumToFixed2 }}</td>
            <td>{{ asiakas.avoinna_kpl }}</td>
          </tr>
          <tr>
            <td>Maksettu</td>
            <td>{{ asiakas.maksettu_summa | formatSumToFixed2 }}</td>
            <td>{{ asiakas.maksettu_kpl }}</td>
          </tr>
          <tr>
            <td>Perinnässä</td>
            <td>{{ asiakas.perinnassa_summa | formatSumToFixed2 }}</td>
            <td>{{ asiakas.perinnassa_kpl }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>

export default {
  name: 'AsiakasLaskutuksenYhteenveto',
  props: {
    asiakas: {
      type: Object,
      required: true,
    },
    titleClass: {
      type: String,
      required: false,
      default () {
        return ''
      }
    },
  },
}

</script>

<style lang="scss" scoped>

</style>

